<div class="v2-card"
     [class.v2-card--info]="tone() === 'info'"
     [class.v2-card--danger]="tone() === 'danger'"
     [class.v2-card--compact]="padding() === 'compact'"
     [class.v2-card--flush]="padding() === 'none'">
  <ng-content select="[slot=header]" />
  <div class="v2-card__body">
    <ng-content />
  </div>
  <ng-content select="[slot=footer]" />
</div>
